module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateDuplicateModal",
    attrs: {
      "id": "missionSlotTemplateDuplicateModal",
      "title": _vm.$t('mission.slotTemplate.modal.duplicate'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotTemplateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.duplicateMissionSlotTemplate($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.slotTemplate.duplicate.description'))
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": "success",
      "description": _vm.$t('mission.slotTemplate.duplicate.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionSlotTemplateDuplicateData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateDuplicateData.title = $$v
      },
      expression: "missionSlotTemplateDuplicateData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": "success",
      "description": _vm.$t('mission.slotTemplate.duplicate.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotTemplateDuplicateVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateDuplicateData.visibility),
      callback: function($$v) {
        _vm.missionSlotTemplateDuplicateData.visibility = $$v
      },
      expression: "missionSlotTemplateDuplicateData.visibility"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template duplicate actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.duplicateMissionSlotTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateDuplicateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c504629"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateDuplicateModal.vue
// module id = 516
// module chunks = 0